import { render } from "./hazards-list.vue?vue&type=template&id=1d9a1f58"
import script from "./hazards-list.vue?vue&type=script&lang=js"
export * from "./hazards-list.vue?vue&type=script&lang=js"

import "./hazards-list.vue?vue&type=style&index=0&id=1d9a1f58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__